import { Injectable } from '@angular/core';
@Injectable()
export class StaticViewDataService {

  public static externalPageAPI = '/api/cms/page/external';
  public static pageLockAcquireAPI = '/api/cms/lock/acquire/page';
  public static pageLockReleaseAPI = '/api/cms/lock/release/page';
  public static Video_listing_AuthToken = 'Bearer 55d6895dgdc74efdbcb42f654f7e9d10';
  public static Story_listing_View = {
    'view_id': 'all_stories',
    'list_router': '/dash/story',
    'name': 'All Stories',
    'socketCodes': [1, 2, 7],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/dashboard/meta',
      suggestion: '/api/cms/story/suggestions',
      unlock: '/api/cms/unlock/article'
    },
    fields: '&fields=reusable,metadata.markUnimportant,metadata.notificationSent,quickReadStatus,metadata.killed,metadata.tags,metadata.breakingNews,metadata.plagiarismChecked,metadata.plagiarisedContent,metadata.sponsored,lockedByUserId,id,status,lockedByUserName,imageAmpValidated,metadata.status,articleType,elements,metadata.url,title,type,metadata.section,metadata.authors,lastModifiedDate,lastModifiedByUserName,metadata.authorsList,readByUsers,mobileHeadline,metadata.ampStatus,summaryStatus,firstPublishedDate',
    sortBy: 'lastModifiedDate',
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'title',
        'class': 'headline spImg',
        'type': 'text',
        'conditionOn': 1
      },
      {
        'header_id': 'format',
        'name': 'Type',
        'model_id': 'type',
        'class': 'format',
        'type': 'text',
        'showIcon': true

      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'metadata.status',
        'class': 'status',
        'type': 'status',
        'colorCondition': true
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'metadata.section',
        'class': 'format',
        'type': 'text'
      },
      {
        'header_id': 'byline',
        'name': 'Byline',
        'model_id': 'metadata.authors[0]',
        'class': 'author',
        'type': 'text'
      },
      {
        'header_id': 'lastupdae',
        'name': 'Last Updated On',
        'model_id': 'lastModifiedDate',
        'class': 'lastupdae',
        'type': 'date',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate'
      },
      {
        'header_id': 'lastModifiedBy',
        'name': 'Updated By',
        'model_id': 'lastModifiedByUserName',
        'class': 'lastModifiedBy',
        'type': 'text'
      }
    ],
    'filters': [
      {
        "filter_id": "domain",
        "name": "Domain",
        "facet_name_meta": "flags",
        "facet_name": "domainId",
        "type": "domainList"

      },
      {
        'filter_id': 'byline',
        'name': 'Byline',
        'facet_name_meta': 'authorNames',
        'facet_name': 'metadata.authors',
        'type': 'api_filter'
      },
      {
        'filter_id': 'createdon',
        'name': 'Created On',
        'facet_name_meta': 'createdDate',
        'facet_name': 'createdDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'format',
        'name': 'Type',
        'facet_name_meta': 'types',
        'facet_name': 'type',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'statuses',
        'facet_name': 'metadata.status',
        'type': 'checkbox'
      },
      {
        'filter_id': 'social',
        'name': 'Social',
        'facet_name_meta': 'social',
        'facet_name': 'social',
        'type': 'social',
        'social': 'social'

        // 'filter_id': 'updated',
        // 'name': 'Updated',
        // 'facet_name_meta': 'lastModifiedDate',
        // 'facet_name': 'lastModifiedDate',
        // 'type': 'daterange'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'metadata.section',
        'type': 'checkbox'
      },

      {
        'filter_id': 'lastModifiedByUserName',
        'name': 'Created by',
        'facet_name_meta': 'createdBy',
        'facet_name': 'createdBy',
        'type': 'api_filter'
      },
      {
        'filter_id': 'agency',
        'name': 'Agency',
        'facet_name_meta': 'agencies',
        'facet_name': 'metadata.agency',
        'type': 'checkbox'
      },
      {
        'filter_id': 'flags',
        'name': 'Category',
        'facet_name_meta': 'flags',
        'facet_name': 'metadata',
        'type': 'radio',
        'social': 'social'
      },
      {
        "filter_id": "firstPublishedDate",
        "name": "First Published Date",
        "facet_name_meta": "firstPublishedDate",
        "facet_name": "firstPublishedDate",
        "type": "daterange"
      }
    ]
  };

  public static Element_listing_View = {
    'view_id': 'element',
    'name': 'Element',
    'socketCodes': [1, 8],
    'list_router': '/dash/element',
    'urls': {
      listing: '/api/cms/elements',
      meta: '/api/cms/element/meta',
      unlock: '/api/cms/unlock/article'
    },
    fields: '&fields=reusable,metadata.markUnimportant,metadata.killed,metadata.tags,metadata.breakingNews,metadata.sponsored,lockedByUserId,id,status,lockedByUserName,imageAmpValidated,metadata.status,articleType,elements,metadata.url,title,type,metadata.status,lastModifiedDate,lastModifiedByUserName,chart',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'get_element',
        'url': '/api/cms/element'
      },
      {
        'api_id': 'all_elements',
        'url': '/api/cms/elements'
      },
      {
        'api_id': 'save_element',
        'url': '/api/cms/element'
      },
      {
        'api_id': 'search_elements',
        'url': '/api/cms/elements'
      },
      {
        'api_id': 'element_meta',
        'url': '/api/cms/element/meta'
      },
      {
        'api_id': 'lock_acquire',
        'url': '/api/cms/lock/acquire/article'
      },
      {
        'api_id': 'lock_release',
        'url': '/api/cms/lock/release/article'
      },
      {
        'api_id': 'unlock',
        'url': '/api/cms/unlock/article'
      },
      {
        'api_id': 'update_parent',
        'url': '/api/cms/element/parent'
      }
    ],
    'headers': [
      {
        'header_id': 'name',
        'name': 'Name',
        'model_id': 'title',
        'class': 'name',
        'type': 'text',
        'lockpage': 1,
        'conditionOn': 1,
        'bytype': 1,
        'showIcon': 1
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'metadata.status',
        'class': 'status',
        'type': 'text',
        'colorCondition': true
      },
      {
        'header_id': 'lastModifiedBy',
        'name': 'Updated By',
        'model_id': 'lastModifiedByUserName',
        'class': 'lastModifiedBy',
        'type': 'text'
      },
      {
        'header_id': 'lastupdae',
        'name': 'Last Updated On',
        'model_id': 'lastModifiedDate',
        'class': 'lastupdae',
        'type': 'date',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate'
      },
      {
        'header_id': 'type',
        'name': 'Type',
        'model_id': 'type',
        'class': 'lastModifiedBy',
        'type': 'text'
      }

    ],
    'filters': [
      {
        'filter_id': 'createdon',
        'name': 'Created On',
        'facet_name_meta': 'createdDate',
        'facet_name': 'createdDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'updated',
        'name': 'Updated',
        'facet_name_meta': 'lastModifiedDate',
        'facet_name': 'lastModifiedDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'type',
        'name': 'Type',
        'facet_name_meta': 'elementTypes',
        'facet_name': 'type',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'statuses',
        'facet_name': 'metadata.status',
        'type': 'checkbox'
      },
      {
        'filter_id': 'createdBy',
        'name': 'Created by',
        'facet_name_meta': 'createdBy',
        'facet_name': 'createdBy',
        'type': 'api_filter'
      },
      {
        'filter_id': 'lastModifiedByUserName',
        'name': 'Lastmodified by',
        'facet_name_meta': 'lastModifiedByUserName',
        'facet_name': 'lastModifiedByUserName',
        'type': 'api_filter'
      }
    ],
    'buttons': []
  };
  public static Report_listing_View = {
    'view_id': 'element',
    'name': 'Element',
    'socketCodes': [1, 8],
    'list_router': '/dash/element',
    'urls': {
      listing: '/api/cms/elements',
      meta: '/api/cms/element/meta',
      unlock: '/api/cms/unlock/article'
    },
    fields: '&fields=reusable,metadata.markUnimportant,metadata.killed,metadata.tags,metadata.breakingNews,metadata.sponsored,lockedByUserId,id,status,lockedByUserName,imageAmpValidated,metadata.status,articleType,elements,metadata.url,title,type,metadata.status,lastModifiedDate,lastModifiedByUserName,chart',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'get_element',
        'url': '/api/cms/element'
      },
      {
        'api_id': 'all_elements',
        'url': '/api/cms/elements'
      },
      {
        'api_id': 'save_element',
        'url': '/api/cms/element'
      },
      {
        'api_id': 'search_elements',
        'url': '/api/cms/elements'
      },
      {
        'api_id': 'element_meta',
        'url': '/api/cms/element/meta'
      },
      {
        'api_id': 'lock_acquire',
        'url': '/api/cms/lock/acquire/article'
      },
      {
        'api_id': 'lock_release',
        'url': '/api/cms/lock/release/article'
      },
      {
        'api_id': 'unlock',
        'url': '/api/cms/unlock/article'
      },
      {
        'api_id': 'update_parent',
        'url': '/api/cms/element/parent'
      }
    ],
    'headers': [
      {
        'header_id': 'reportType',
        'name': 'Report Type',
        'model_id': 'title',
        'class': 'reportType',
        'type': 'text',
        'lockpage': 1,
        'conditionOn': 1,
        'bytype': 1,
        'showIcon': 1
      },
      {
        'header_id': 'dateRange',
        'name': 'Date Range',
        'model_id': 'dateRange',
        'class': 'dateRange',
        'type': 'text'
      },
      {
        'header_id': 'reportGenerated',
        'name': 'Report Generated On',
        'model_id': 'lastModifiedDate',
        'class': 'lastupdae',
        'type': 'date',
      },
      {
        'header_id': 'generatedBy',
        'name': 'Report Generated By',
        'model_id': 'generatedBy',
        'class': 'generatedBy',
        'type': 'text',
      },
      {
        'header_id': 'download',
        'name': 'Download',
        'model_id': 'type',
        'class': 'donwload',
        'type': 'text'
      }

    ],
    'filters': [
      {
        'filter_id': 'createdon',
        'name': 'Created On',
        'facet_name_meta': 'createdDate',
        'facet_name': 'createdDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'updated',
        'name': 'Updated',
        'facet_name_meta': 'lastModifiedDate',
        'facet_name': 'lastModifiedDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'type',
        'name': 'Type',
        'facet_name_meta': 'elementTypes',
        'facet_name': 'type',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'statuses',
        'facet_name': 'metadata.status',
        'type': 'checkbox'
      },
      {
        'filter_id': 'createdBy',
        'name': 'Created by',
        'facet_name_meta': 'createdBy',
        'facet_name': 'createdBy',
        'type': 'api_filter'
      },
      {
        'filter_id': 'lastModifiedByUserName',
        'name': 'Lastmodified by',
        'facet_name_meta': 'lastModifiedByUserName',
        'facet_name': 'lastModifiedByUserName',
        'type': 'api_filter'
      }
    ],
    'buttons': []
  };

  public static video_cms_listing_View = {
    'view_id': 'video_cms',
    'name': 'video_cms',
    'list_router': '/dash/video-cms-list',
    'subPages': [],
    'urls': {
      listing: '/api/cms/video/list',
      unlock: '/api/cms/video/lock',
      meta: '/api/cms/dashboard/meta',
    },
    fields: '&fields=requestId',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'all_pages',
        'name': 'All Pages',
        'url': '/api/cms/video/list'
      },
      {
        'api_id': 'search_pages',
        'name': 'Feeds',
        'url': '/api/cms/video/list'
      },
      {
        'api_id': 'get_page',
        'name': 'Page Get',
        'url': '/api/cms/video'
      },
    ],
    'headers': [
      {
        'header_id': 'videotitle',
        'name': 'Video Title',
        'model_id': 'cmsVideoMetadata.videoTitle',
        'class': 'name',
        'type': 'text',
        'lockpage': 1,
        'showIcon': false
      },
      // {
      //   'header_id': 'videostatus',
      //   'name': 'Video Status',
      //   'model_id': 'cmsVideoStatus',
      //   'class': 'name',
      //   'type': 'text',
      //   'lockpage': 1,
      //   'showIcon': false
      // },
      {
        'header_id': 's3status',
        'name': 'S3 Status',
        'model_id': 's3LongVideoUploadStatus',
        'class': 'statusS3YT',
        'type': 'text',
        'lockpage': 1,
        'showIcon': false
      },
      {
        'header_id': 'ytstatus',
        'name': 'YT Status',
        'model_id': 'ytPrimaryUploadStatus',
        'class': 'statusS3YT',
        'type': 'text',
        'lockpage': 1,
        'showIcon': false
      },
      {
        'header_id': 'ytchannel',
        'name': 'Saranyu Status',
        'model_id': 'ytPrimaryUploadStatus',
        'class': 'statusS3YT',
        'type': 'text',
        'lockpage': 1,
        'showIcon': false
      },
      {
        'header_id': 'createdDate',
        'name': 'Uploaded On',
        'sortDataBy': 1,
        'sortByValue': 'createdDate',
        'model_id': 'createdDate',
        'class': 'lastupdae',
        'type': 'date'
      },
      {
        'header_id': 'lastModifiedDate',
        'name': 'Last Updated On',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate',
        'model_id': 'lastModifiedDate',
        'class': 'lastupdae',
        'type': 'date'
      },
      {
        'header_id': 'lastModifiedBy',
        'name': 'Updated By',
        'model_id': 'lastModifiedByUserName',
        'class': 'lastModifiedBy',
        'type': 'text'
      },
      // {
      //   'header_id': 'download',
      //   'name': 'Download',
      //   'model_id': 'type',
      //   'class': 'download',
      //   'type': 'text'
      // },
      {
        'header_id': 'download',
        'name': 'View',
        'model_id': 'type',
        'class': 'statusS3YT',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'created',
        'name': 'Created on',
        'facet_name_meta': 'createdDate',
        'facet_name': 'createdDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'lastModified',
        'name': 'Last Modified On',
        'facet_name_meta': 'lastModifiedDate',
        'facet_name': 'lastModifiedDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'ytStatus',
        'name': 'YouTube Status',
        'facet_name_meta': 'statuses',
        'facet_name': 'ytPrimaryUploadStatus',
        'type': 'checkbox'
      },
      {
        'filter_id': 's3Status',
        'name': 'S3 Status',
        'facet_name_meta': 'statuses',
        'facet_name': 's3LongVideoUploadStatus',
        'type': 'checkbox'
      },
      {
        'filter_id': 'saranyuUploadStatus',
        'name': 'Saranyu Status',
        'facet_name_meta': 'saranyuStatus',
        'facet_name': 'saranyuUploadStatus',
        'type': 'checkbox'
      },
      {
        'filter_id': 'createdBy',
        'name': 'Uploaded to S3 by',
        'facet_name_meta': 'createdBy',
        'facet_name': 'createdBy',
        'facet_key': 'lastUploadedOnS3By',
        'type': 'api_filter'
      },
      {
        'filter_id': 'createdBy',
        'name': 'Uploaded to YT by',
        'facet_name_meta': 'createdBy',
        'facet_name': 'createdBy',
        'facet_key': 'lastUploadedOnYTBy',
        'type': 'api_filter'
      }
    ],
    'facets':
    {
      'statuses':
      {
        'INPROGRESS': 0,
        'UPLOADED': 0,
        'UPDATED': 0,
        'FAILED': 0,
        'NOTEXIST': 0,
        'DONE': 0
      },
      'saranyuStatus':{
        'INPROGRESS': 0,
        'PUBLISHED': 0,
        'TRANSCODING': 0,
        'NOTEXIST': 0,
        'TRANSCODING ERROR': 0
      }
    }
  };

  public static Page_listing_View = {
    'view_id': 'pages',
    'name': 'Pages',
    'list_router': '/dash/page',
    'socketCodes': [5, 6],
    'subPages': [],
    'urls': {
      listing: '/api/cms/page/search',
      meta: '/api/cms/page/meta',
      unlock: '/api/cms/unlock/page',
      excel: '/api/cms/report/downoadPageListing'
    },
    fields: '&fields=reusable,metadata.markUnimportant,metadata.killed,metadata.tags,metadata.breakingNews,metadata.sponsored,lockedByUserId,id,status,lockedByUserName,imageAmpValidated,metadata.status,articleType,elements,metadata.url,title,name,url,lastModifiedDate,lastModifiedByUserName,pageType,storiesCount,storiesCountLastUpdatedOn',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'all_pages',
        'name': 'All Pages',
        'url': '/api/cms/page/search'
      },
      {
        'api_id': 'search_pages',
        'name': 'Feeds',
        'url': '/api/cms/page/search'
      },
      {
        'api_id': 'one_page',
        'name': 'One Page',
        'url': '/api/cms/page'
      },
      {
        'api_id': 'pages_meta',
        'name': 'Pages Meta',
        'url': '/api/cms/page/meta'
      },
      {
        'api_id': 'save_page',
        'name': 'Pages save',
        'url': '/api/cms/page/'
      },
      {
        'api_id': 'get_page',
        'name': 'Page Get',
        'url': '/api/cms/page'
      },
      {
        'api_id': 'delete_articlefrompage',
        'name': 'Article Delete',
        'url': '/api/cms/page/remove/article'
      },
      {
        'api_id': 'page_lock_acquire',
        'name': 'Page Lock Acquire',
        'url': '/api/cms/lock/acquire/page'
        // /api/cms/lock/acquire/page
      },
      {
        'api_id': 'page_lock_release',
        'name': 'Page Lock Release',
        'url': '/api/cms/lock/release/page'
      },
      {
        'api_id': 'page_unlock',
        'name': 'Page Lock Release',
        'url': '/api/cms/unlock/page'
      },
      {
        'api_id': 'page_versions',
        'name': 'Page Versions',
        'url': '/api/cms/story/versions'
      },
      {
        'api_id': 'page_list',
        'name': 'Page List',
        'url': '/api/cms/page/articles/'
      },
      {
        'api_id': 'page_putArticle',
        'name': 'Page Put Article',
        'url': '/api/cms/page/add/article/'
      }

    ],
    'headers': [
      {
        'header_id': 'name',
        'name': 'Name',
        'model_id': 'name',
        'class': 'name',
        'type': 'text',
        'lockpage': 1,
        'showIcon': false
      },
      {
        'header_id': 'URL',
        'name': 'URL',
        'model_id': 'url',
        'class': 'url',
        'type': 'url',
        'showIcon': false
      },
      {
        'header_id': 'lastModifiedDate',
        'name': 'Last Updated On',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate',
        'model_id': 'lastModifiedDate',
        'class': 'lastModifiedDate',
        'type': 'date'
      },
      {
        'header_id': 'lastModifiedBy',
        'name': 'Updated By',
        'model_id': 'lastModifiedByUserName',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'type',
        'name': 'Type',
        'model_id': 'pageType',
        'class': 'type',
        'type': 'text'
      },
      {
        'header_id': 'storiesCount',
        'name': 'Story Count',
        'model_id': 'storiesCount',
        'class': 'type',
        'type': 'text'
      },
      {
        'header_id': 'storiesCountLastUpdatedOn',
        'name': 'Count Last Updated On',
        'model_id': 'storiesCountLastUpdatedOn',
        'class': 'type',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'created',
        'name': 'Created on',
        'facet_name_meta': 'creationDate',
        'facet_name': 'creationDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'lastPublishedDate',
        'facet_name': 'lastPublishedDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'type',
        'name': 'Type',
        'facet_name_meta': 'types',
        'facet_name': 'pageType',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Page Status',
        'facet_name_meta': 'statuses',
        'facet_name': 'status',
        'type': 'checkbox'
      },
      {
        'filter_id': 'toBeAutobacklink',
        'name': 'To Be Autbacklinked',
        'facet_name_meta': 'toBeAutobacklink',
        'facet_name': 'toBeAutobacklink',
        'type': 'radio'
      },
      {
        'filter_id': 'storyCount',
        'name': 'Story Count',
        'facet_name_meta': 'storiesCount',
        'facet_name': 'storiesCount',
        'type': 'comparetextbox'
      }

    ]
  };

  public static Left_Menu_View = {
    'view_id': 'left_menu',
    'name': 'Left Menu',
    'apiEndPoints': [],
    'buttons': [
      {
        'name': 'Dashboard',
        'router_link': './workspace',
        'class': 'dashboard',
        'alternateClass': 'icon-dashboard-active',
        'active': 1,
        'enable': true
      },
      {
        'name': 'All Elements',
        'router_link': './elements',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'active': 1,
        'enable': true
      },
      {
        'name': 'Education',
        'router_link': './education',
        'class': 'allCards',
        'alternateClass': 'icon-cards1',
        'active': 1,
        'enable': false
      },
      {
        'name': 'Entertainment',
        'router_link': './entertainment',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'active': 1,  
        'enable':false
      },
      {
        'name': 'Pages',
        'router_link': './pages',
        'class': 'pages',
        'alternateClass': 'icon-pages',
        'active': 1,
        'enable': true
      },
      {
        'name': 'Feeds',
        'router_link': './wire',
        'class': 'feeds',
        'alternateClass': 'icon-feeds',
        'active': 1,
        'enable': true
      },
      {
        'name': 'Translated Feeds',
        'router_link': './translated-wire',
        'class': 'translatedFeeds',
        'alternateClass': 'icon-feeds',
        'active': 1,
        'enable': false
      },
      {
        'name': 'Trends',
        'enable': true
      },
      {
        'name': 'Videos',
        'router_link': './videos',
        'class': 'videos',
        'alternateClass': 'icon-video',
        'active': 1,
        'enable': true
      },
      {
        'name': 'Images',
        'router_link': './images',
        'class': 'images',
        'alternateClass': 'icon-image-library',
        'active': 1,
        'enable': true
      },
      {
        'name': 'Users',
        'router_link': './users',
        'class': 'users',
        'alternateClass': 'icon-user-management',
        'active': 1,
        'enable': true
      },
      {
        'name': 'Reports',
        'router_link': './reports',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'enable': false
      }, {
        'name': 'Analytics',
        'router_link': './analytics',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'enable':false
      },
      {
        'name': 'VideoCMS',
        'router_link': './video-cms-list',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'enable': false
      },
      {
        'name': 'Microsite',
        'router_link': './ms-dash',
        'class': 'allCards',
        'alternateClass': 'icon-cards',
        'enable': false
      }
    ]
  };

  public static Notification_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/analytics/notifications',
      meta: '/api/cms/analytics/notifications/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'notificationTitle',
        'name': 'Notification Title',
        'model_id': 'notificationTitle',
        'class': 'notification-title',
        'type': 'text'
      },
      {
        'header_id': 'notificationDescription',
        'name': 'Notification Description',
        'model_id': 'notificationDescription',
        'class': 'notification-description',
        'type': 'text'
      },
      {
        'header_id': 'setTimeAndDate',
        'name': 'Set Time And Date',
        'model_id': 'setTimeAndDate',
        'class': 'notification-time',
        'type': 'text'
      },
      {
        'header_id': 'notificationType',
        'name': 'Notification Type',
        'model_id': 'notificationType',
        'class': 'notification-type',
        'type': 'text'
      },
      {
        'header_id': 'targetApps',
        'name': 'Target Apps',
        'model_id': 'targetApps',
        'class': 'target-apps',
        'type': 'text'
      },
      {
        'header_id': 'sentBy',
        'name': 'Sent By',
        'model_id': 'sentBy',
        'class': 'notification-sent-by',
        'type': 'text'
      },
      {
        'header_id': 'storyTitle',
        'name': 'Story Title',
        'model_id': 'storyTitle',
        'class': 'notification-story-title',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'createdDate',
        'name': 'Sent Time',
        'facet_name_meta': 'createdDate',
        'facet_name': 'createdDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'format',
        'name': 'Send By',
        'facet_name_meta': 'CreatedBy',
        'facet_name': 'createdByUserName',
        'type': 'checkbox'
      },
      {
        'filter_id': 'format',
        'name': 'Notification Type',
        'facet_name_meta': 'NotificationType',
        'facet_name': 'notificationType',
        'type': 'checkbox'
      },
      {
        'filter_id': 'tagetapps',
        'name': 'Target Apps',
        'facet_name_meta': 'AppTypes',
        'facet_name': 'appTypes',
        'type': 'checkbox'
      },
    ]
  };

  public static Celebrity_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'list_router': '/dash/entertainment/addcelebrity',
    'urls': {
      listing: '/api/cms/celebrity',
      professions: '/api/cms/celebrity/professions',
      genre: '/api/cms/movie/genres',
      platform:'/api/cms/celebrity/platforms',
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [],
    'headers': [
      {
        'header_id': 'celebrityName',
        'name': 'Celebrity Name',
        'model_id': 'celebrityName',
        'class': 'college-name',
        'type': 'text'
      },
      // {
      //   'header_id': 'nickName',
      //   'name': 'Nick Name',
      //   'model_id': 'nickName',
      //   'class': 'college-details',
      //   'type': 'text'
      // },
      // {
      //   'header_id': 'maritalStatus',
      //   'name': 'Marital Status',
      //   'model_id': 'maritalStatus',
      //   'class': 'college-details',
      //   'type': 'text'
      // },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'college-details',
        'type': 'text'
      },
    ],
    'filters': [
    ]
  };

  public static Movie_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'list_router': '/dash/entertainment/addmovie',
    'urls': {
      listing: '/api/cms/movie',
      genre: '/api/cms/movie/genres',
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [],
    'headers': [
      {
        'header_id': 'movieName',
        'name': 'Movie Name',
        'model_id': 'movieName',
        'class': 'college-name',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'college-details',
        'type': 'text'
      },
    ],
    'filters': [
    ]
  };

  public static TvShow_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'list_router': '/dash/entertainment/addtvShow',
    'urls': {
      listing: '/api/cms/tvshow',
      genre: '/api/cms/movie/genres',
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [],
    'headers': [
      {
        'header_id': 'showName',
        'name': 'Show Name',
        'model_id': 'showName',
        'class': 'college-name',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'college-details',
        'type': 'text'
      },
    ],
    'filters': [
    ]
  };

  public static College_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'list_router': '/dash/education/addcollege',
    'urls': {
      listing: '/api/cms/college',
      meta: '/api/cms/college/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions',
      country: '/api/cms/college/country',
      state: '/api/cms/college/state',
      city: '/api/cms/college/city'
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'collegeName',
        'name': 'College Name',
        'model_id': 'collegeName',
        'class': 'college-name',
        'type': 'text'
      },
      {
        'header_id': 'city',
        'name': 'City',
        'model_id': 'city',
        'class': 'college-details',
        'type': 'text'
      },
      {
        'header_id': 'state',
        'name': 'State',
        'model_id': 'state',
        'class': 'college-details',
        'type': 'text'
      },
      {
        'header_id': 'collegeType',
        'name': 'Private/Govt',
        'model_id': 'collegeType',
        'class': 'college-details',
        'type': 'text'
      },
      {
        'header_id': 'rank',
        'name': 'Rank',
        'model_id': 'rank',
        'class': 'college-details',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'college-details',
        'type': 'text'
      },
    ],
    'filters': [
    ]
  };

  public static Course_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/course',
      meta: '/api/cms/analytics/notifications/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'notificationTitle',
        'name': 'Course Name',
        'model_id': 'notificationTitle',
        'class': 'course-name',
        'type': 'text'
      },
      {
        'header_id': 'notificationDescription',
        'name': 'Course Short Name',
        'model_id': 'notificationDescription',
        'class': 'course-short-name',
        'type': 'text'
      },
      {
        'header_id': 'notificationType',
        'name': 'Stream',
        'model_id': 'notificationType',
        'class': 'course-short-name',
        'type': 'text'
      },
    ],
    'filters': [

    ]
  };

  public static Entrance_Exam_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/exam',
      meta: '/api/cms/analytics/notifications/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'entranceExamTitle',
        'name': 'Entrance Exam Name',
        'model_id': 'entranceExamTitle',
        'class': 'exam-name',
        'type': 'text'
      },
      {
        'header_id': 'entranceExamDescription',
        'name': 'Entrance Exam Short Name',
        'model_id': 'entranceExamDescription',
        'class': 'exam-short-name',
        'type': 'text'
      },
      {
        'header_id': 'entranceExamDescription',
        'name': 'Conducted By',
        'model_id': 'entranceExamDescription',
        'class': 'conducatedBy',
        'type': 'text'
      },
      {
        'header_id': 'entranceExamType',
        'name': 'Stream',
        'model_id': 'entranceExamType',
        'class': 'exam-short-name',
        'type': 'text'
      },
    ],
    'filters': [

    ]
  };

  public static Notification_Center_Listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/alerts',
      meta: '/api/cms/notified/topics',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'notificationTitle',
        'name': 'Notification Title',
        'model_id': 'heading',
        'class': 'notification-title',
        'type': 'text'
      },
      {
        'header_id': 'notificationDescription',
        'name': 'Topic',
        'model_id': 'topic',
        'class': 'notification-description',
        'type': 'text'
      },
      {
        'header_id': 'setTimeAndDate',
        'name': 'Updated Date',
        'model_id': 'updateDate',
        'class': 'notification-time',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'updateDate',
        'name': 'Updated',
        'facet_name_meta': 'updateDate',
        'facet_name': 'updateDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'format',
        'name': 'Topic',
        'facet_name_meta': 'topics',
        'facet_name': 'topic',
        'type': 'checkbox'
      },
    ]
  };


  public static AgencyFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'agency',
        'name': 'Agency',
        'model_id': 'agency',
        'class': 'agency',
        'type': 'text'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'agency',
        'name': 'Agency',
        'facet_name_meta': 'agencyNames',
        'facet_name': 'agency',
        'type': 'checkbox'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      }
    ]
  };

  public static TwitterFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/twitter/tweets/all',
      meta: '/api/cms/twitter/tweets/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'twitterMessage',
        'name': 'Twitter Message',
        'model_id': 'twitterMessage',
        'class': 'twitter-message',
        'type': 'text'
      },
      {
        'header_id': 'twitterHandle',
        'name': 'Twitter Handle',
        'model_id': 'twitterHandle',
        'class': 'twitter-handle',
        'type': 'text'
      },
      {
        'header_id': 'date',
        'name': 'Date',
        'model_id': 'date',
        'class': 'twitter-handle',
        'type': 'text'
      },
      {
        'header_id': 'url',
        'name': 'URL',
        'class': 'url',
        'type': 'date'
      },

    ],
    'filters': [
      {
        'filter_id': 'createdDate',
        'name': 'Posted On',
        'facet_name_meta': 'createdDate',
        'facet_name': 'createdDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'twitterHandle',
        'name': 'Twitter Handle',
        'facet_name_meta': 'twitterHandle',
        'facet_name': 'twitterHandle',
        'type': 'checkbox'
      }
    ]
  };

  public static HindiFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'agency',
        'name': 'Agency',
        'model_id': 'agency',
        'class': 'agency',
        'type': 'text'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'agency',
        'name': 'Agency',
        'facet_name_meta': 'agencyNames',
        'facet_name': 'agency',
        'type': 'checkbox'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      }
    ]
  };

  public static photogalleryFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'domainId',
        'name': 'Domains',
        'model_id': 'domains',
        'class': 'webdomainId',
        'type': 'text'
      },
      {
        'header_id': 'publishDate',
        'name': 'Publish Date',
        'model_id': 'publishDate',
        'class': 'publishDate',
        'type': 'text'
      },
      // {
      //   'header_id': 'url',
      //   'name': 'Video Status',
      //   'model_id': 'url',
      //   'class': 'url',
      //   'type': 'text'
      // },
      {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      }
    ]
  };

  public static webStoryFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline-web',
        'type': 'text'
      },
      {
        'header_id': 'domainId',
        'name': 'Domains',
        'model_id': 'domains',
        'class': 'domainId',
        'type': 'text'
      },
      {
        'header_id': 'publishDate',
        'name': 'Publish Date',
        'model_id': 'publishDate',
        'class': 'publishDate',
        'type': 'text'
      },
      // {
      //   'header_id': 'url',
      //   'name': 'URL',
      //   'model_id': 'url',
      //   'class': 'url',
      //   'type': 'text'
      // },
      // {
      //   'header_id': 'aiVideoStatus',
      //   'name': 'Video Status',
      //   'model_id': 'status',
      //   'class': 'url',
      //   'type': 'text'
      // }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      }
    ]
  };
  public static webstoryFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'domainId',
        'name': 'Domains',
        'model_id': 'domains',
        'class': 'domainId',
        'type': 'text'
      },
      {
        'header_id': 'publishDate',
        'name': 'Publish Date',
        'model_id': 'publishDate',
        'class': 'publishDate',
        'type': 'text'
      },
      {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        "filter_id": "firstPublishedDate",
        "name": "First Published Date",
        "facet_name_meta": "firstPublishedDate",
        "facet_name": "firstPublishedDate",
        "type": "daterange"
      }
    ]
  };
  public static storyFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/dashboard/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'domainId',
        'name': 'Domains',
        'model_id': 'domains',
        'class': 'domainId',
        'type': 'text'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'metadata.section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'publishDate',
        'name': 'Publish Date',
        'model_id': 'publishDate',
        'class': 'publishDate',
        'type': 'text'
      },
      {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        "filter_id": "domain",
        "name": "Domain",
        "facet_name_meta": "flags",
        "facet_name": "domainId",
        "type": "domainCheckbox"
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'metadata.section',
        'type': 'SectionCheckbox'
      }
    ]
  };

  public static AIgalleryFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'timestamp',
        'name': 'Timestamp',
        'model_id': 'timestamp',
        'class': 'timestamp',
        'type': 'text'
      },
      {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'timestamp',
        'name': 'timestamp',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      }
    ]
  };

  public static translaationFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'seciton',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'publishedDate',
        'name': 'Published Date',
        'model_id': 'publishedDate',
        'class': 'publishedDate',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'lastPublishedDate',
        'facet_name': 'lastPublishedDate',
        'type': 'daterange'
      }
    ]
  };

  public static competetionData_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/competition/filtered-stories',
      meta: '/api/cms/competition/getdomains',
    },
    fields: '',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'news_category',
        'name': 'News Category',
        'model_id': 'news_category',
        'class': 'news_category',
        'type': 'text'
      },
      {
        'header_id': 'sitename',
        'name': 'Sitename',
        'model_id': 'sitename',
        'class': 'sitenamey',
        'type': 'text'
      },
      {
        'header_id': 'url',
        'name': 'URL',
        'model_id': 'url',
        'class': 'url',
        'type': 'text'
      },
      {
        'header_id': 'publishedDate',
        'name': 'Published Date',
        'model_id': 'publishedDate',
        'class': 'publishedDate',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'lastPublishedDate',
        'facet_name': 'startTime',
        'type': 'dateRangeWithTime'
      },
      {
        'filter_id': 'domains',
        'name': 'SiteName',
        'facet_name_meta': 'domains',
        'facet_name': 'sitename',
        'type': 'siteNameCheckbox'
      },
    ]
  };

  public static PrintFeed_listing_View = {
    'view_id': 'print_wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'issue_date',
        'name': 'Issue Date',
        'model_id': 'issueDate',
        'class': 'agency',
        'type': 'date_day'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'status',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'issued',
        'name': 'Issued At',
        'facet_name_meta': 'issueDate',
        'facet_name': 'issueDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'received',
        'name': 'Received At',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'status',
        'facet_name': 'status',
        'type': 'checkbox'
      }
    ]
  };

  public static LH_PrintFeed_listing_View = {
    'view_id': 'print_wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt_LH_print',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'received',
        'name': 'Received At',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      }
    ]
  };

  public static Microsite_listing_View = {
    'view_id': 'microsite_listing',
    'name': 'Microsite Listing',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/microsite/search',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'updateDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'name',
        'name': 'Name',
        'model_id': 'name',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'first_page_url',
        'name': 'First Page URL',
        'model_id': 'first_page_url',
        'class': 'agency',
        'type': 'date_day'
      },
      {
        'header_id': 'pageNum',
        'name': 'Number of Pages',
        'model_id': 'pageNum',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'updatedByUserName',
        'name': 'Updated By',
        'model_id': 'updatedByUserName',
        'class': 'status',
        'type': 'text'
      },
      {
        'header_id': 'lastUpdated',
        'name': 'Last Updated',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate',
        'model_id': 'lastModifiedDate',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'section',
        'type': 'text'
      }
    ],
    'filters': [
    ]
  };

  public static Template_listing_View = {
    'view_id': 'microsite_listing',
    'name': 'Microsite Listing',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/microsite/template/search',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'updateDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'name',
        'name': 'Name',
        'model_id': 'name',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'pageNum',
        'name': 'Number of Pages',
        'model_id': 'pageCount',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'updatedBy',
        'name': 'Last Updated By',
        'model_id': 'updatedBy',
        'class': 'status',
        'type': 'text'
      },
      {
        'header_id': 'lastUpdated',
        'name': 'Last Updated',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate',
        'model_id': 'lastModifiedDate',
        'class': 'receivedAt',
        'type': 'date'
      }
    ],
    'filters': [
    ]
  };

  public static EconomistFeed_listing_View = {
    'view_id': 'print_wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions',
      data: '/api/cms/wire/data'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      },
      {
        'api_id': 'wire_feeds_data',
        'name': 'Wire Feeds Data',
        'url': '/api/cms/wire/data'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'issue_date',
        'name': 'Issue Date',
        'model_id': 'issueDate',
        'class': 'agency',
        'type': 'date_day'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'status',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'issued',
        'name': 'Issued At',
        'facet_name_meta': 'issueDate',
        'facet_name': 'issueDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'received',
        'name': 'Received At',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'status',
        'facet_name': 'status',
        'type': 'checkbox'
      }
    ]
  };

  public static EconomistFeedCurrent_listing_View = {
    'view_id': 'print_wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions',
      data: '/api/cms/wire/data'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      },
      {
        'api_id': 'wire_feeds_data',
        'name': 'Wire Feeds Data',
        'url': '/api/cms/wire/data'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'issue_date',
        'name': 'Issue Date',
        'model_id': 'issueDate',
        'class': 'agency',
        'type': 'date_day'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'status',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'issued',
        'name': 'Issued At',
        'facet_name_meta': 'issueDate',
        'facet_name': 'issueDate',
        'type': 'daterangeEconomist'
      },
      {
        'filter_id': 'received',
        'name': 'Received At',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'status',
        'facet_name': 'status',
        'type': 'checkbox'
      }
    ]
  };

  public static EconomistFeedArchive_listing_View = {
    'view_id': 'print_wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions',
      data: '/api/cms/wire/data'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      },
      {
        'api_id': 'wire_feeds_data',
        'name': 'Wire Feeds Data',
        'url': '/api/cms/wire/data'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'issue_date',
        'name': 'Issue Date',
        'model_id': 'issueDate',
        'class': 'agency',
        'type': 'date_day'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'status',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'issued',
        'name': 'Issued At',
        'facet_name_meta': 'issueDate',
        'facet_name': 'issueDate',
        'type': 'daterangeEconomistArchive'
      },
      {
        'filter_id': 'received',
        'name': 'Received At',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'status',
        'facet_name': 'status',
        'type': 'checkbox'
      }
    ]
  };

  public static wsjFeed_listing_View = {
    'view_id': 'print_wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/mint/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions',
      data: '/api/cms/wire/data'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/mint/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      },
      {
        'api_id': 'wire_feeds_data',
        'name': 'Wire Feeds Data',
        'url': '/api/cms/wire/data'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'issue_date',
        'name': 'Issue Date',
        'model_id': 'issueDate',
        'class': 'agency',
        'type': 'date_day'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'status',
        'class': 'status',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'issued',
        'name': 'Issued At',
        'facet_name_meta': 'issueDate',
        'facet_name': 'issueDate',
        'type': 'daterange'
      },
      {
        'filter_id': 'received',
        'name': 'Received At',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      },
      {
        'filter_id': 'status',
        'name': 'Status',
        'facet_name_meta': 'status',
        'facet_name': 'status',
        'type': 'checkbox'
      }
    ]
  };
  

  public static CompetitionFeed_listing_View = {
    'view_id': 'pulse_wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'firstPublishedTimestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'agency',
        'name': 'Agency',
        'model_id': 'agency',
        'class': 'agency',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Published On',
        'sortDataBy': 1,
        'sortByValue': 'firstPublishedTimestamp',
        'model_id': 'firstPublishedTimestamp',
        'class': 'receivedAt',
        'type': 'date'
      },
      {
        'header_id': 'pickURL',
        'name': 'URL',
        'model_id': 'story[0].content',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'agency',
        'name': 'Agency',
        'facet_name_meta': 'agencyNames',
        'facet_name': 'agency',
        'type': 'checkbox'
      }
    ]
  };

  public static VideoService_listing_View = {
    'view_id': 'videoStory',
    'name': 'Videos',
    'socketCodes': [],
    'subPages': [],
    'urls': {
      listing: '/v1/videos'
    },
    'apiEndPoints': [
      {
        'api_id': 'video_stories',
        'name': 'Video Stories',
        'url': '/v1/videos'
      },
      {
        'api_id': 'video_search',
        'name': 'Video Search',
        'url': ''
      }
    ],
    'headers': [],
    'filters': [{
      'filter_id': 'sitename',
      'name': 'Source',
      'facet_name_meta': 'sitename',
      'facet_name': 'sitename',
      'type': 'checkbox'
    }]
  };



  public static AffiliateFeed_listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/wires',
      meta: '/api/cms/wire/meta',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'agency',
        'name': 'Agency',
        'model_id': 'agency',
        'class': 'agency',
        'type': 'text'
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'section',
        'class': 'section',
        'type': 'text'
      },
      {
        'header_id': 'receivedAt',
        'name': 'Received At',
        'sortDataBy': 1,
        'sortByValue': 'timestamp',
        'model_id': 'timestamp',
        'class': 'receivedAt',
        'type': 'date'
      }, {
        'header_id': 'pickUp',
        'name': 'Pick Up',
        'model_id': 'pickUp',
        'class': 'pickUp',
        'type': 'component'
      }
    ],
    'filters': [
      {
        'filter_id': 'published',
        'name': 'Published',
        'facet_name_meta': 'timestamp',
        'facet_name': 'timestamp',
        'type': 'daterange'
      },
      {
        'filter_id': 'agency',
        'name': 'Agency',
        'facet_name_meta': 'agencyNames',
        'facet_name': 'agency',
        'type': 'checkbox'
      },
      {
        'filter_id': 'section',
        'name': 'Section',
        'facet_name_meta': 'sections',
        'facet_name': 'section',
        'type': 'checkbox'
      }
    ]
  };


  public static VideoStory_listing_View = {
    'view_id': 'videoServiceStory',
    'list_router': '/dash/story',
    'name': 'Video Service Stories',
    'socketCodes': [1, 2, 7],
    'urls': {
      listing: '/api/cms/stories',
      meta: '/api/cms/dashboard/meta',
      suggestion: '/api/cms/story/suggestions',
      unlock: '/api/cms/unlock/article'
    },
    fields: '',
    sortBy: 'lastModifiedDate',
    'apiEndPoints': [
      {
        'api_id': 'all_story',
        'name': 'All Stories',
        'url': '/api/cms/stories'
      },
      {
        'api_id': 'search_story',
        'name': 'Stories',
        'url': '/api/cms/search/story'
      },
      {
        'api_id': 'search_inPage',
        'name': 'Stories',
        'url': '/api/cms/search/all'
      },
      {
        'api_id': 'dashboard_meta',
        'name': 'Dashboard Meta',
        'url': '/api/cms/dashboard/meta'
      },
      {
        'api_id': 'story_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/story/suggestions'
      },
      {
        'api_id': 'get_story_byids',
        'url': '/api/cms/story/get-all-by-ids/'
      },
      {
        'api_id': 'unlock',
        'url': '/api/cms/unlock/article'
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'title',
        'class': 'headline spImg',
        'type': 'text',
        'conditionOn': 1
      },
      {
        'header_id': 'format',
        'name': 'Type',
        'model_id': 'type',
        'class': 'format',
        'type': 'text',
        'showIcon': true
      },
      {
        'header_id': 'status',
        'name': 'Status',
        'model_id': 'metadata.status',
        'class': 'status',
        'type': 'status',
        'colorCondition': true
      },
      {
        'header_id': 'section',
        'name': 'Section',
        'model_id': 'metadata.section',
        'class': 'format',
        'type': 'text'
      },
      {
        'header_id': 'byline',
        'name': 'Byline',
        'model_id': 'metadata.authors[0]',
        'class': 'author',
        'type': 'text'
      },
      {
        'header_id': 'lastupdae',
        'name': 'Last Updated On',
        'model_id': 'lastModifiedDate',
        'class': 'lastupdae',
        'type': 'date',
        'sortDataBy': 1,
        'sortByValue': 'lastModifiedDate'
      },
      {
        'header_id': 'lastModifiedBy',
        'name': 'Updated By',
        'model_id': 'lastModifiedByUserName',
        'class': 'lastModifiedBy',
        'type': 'text'
      }
    ],
    'filters': [
      {
        "filter_id": "domain",
        "name": "Channel",
        "facet_name_meta": "domains",
        "facet_name": "domains",
        "type": "singleSelectcheckbox"
      }
    ]
  };

  public static Analytics_listing_View = {
    'view_id': 'analytics',
    'name': 'Analytics',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      meta: '/api/cms/dashboard/meta',
      data: '/api/cms/analytics/hourly',
      data2: '/api/cms/analytics/daily',
      userDataHourly: '/api/cms/analytics/user/hourly',
      userDataDaily: '/api/cms/analytics/user/daily',
      notificationDataHourly: '/api/cms/analytics/notification/hourly',
      notificationDataDaily: '/api/cms/analytics/notification/daily',
      daterange: '/api/cms/analytics/daterange',
      userDaterange: '/api/cms/analytics/user/daterange',
      notificationDaterange: '/api/cms/analytics/notification/daterange'
    },
    fields: '',
    sortBy: 'timestamp',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      }
    ],
    'headers': [
      {
        'header_id': 'headline',
        'name': 'Headline',
        'model_id': 'headline',
        'class': 'headline',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'format',
        'name': 'Type',
        'facet_name_meta': 'types',
        'facet_name': 'type',
        'type': 'checkbox'
      },
      {
        'filter_id': 'premium',
        'name': 'Premium Story',
        'facet_name_meta': 'premiumStory',
        'facet_name': 'metadata.premiumStory',
        'type': 'radio'
      },
      {
        'filter_id': 'open-generic',
        'name': 'Open Generic',
        'facet_name_meta': 'opengeneric',
        'facet_name': 'genericopenstory',
        'type': 'radio'
      },
      {
        'filter_id': 'source',
        'name': 'Source',
        'facet_name_meta': 'source',
        'facet_name': 'metadata.storyType',
        'type': 'radio'
      }
    ]
  };

  public static TwitterTrends = {
    'view_id': 'twittertrends',
    'name': 'Twitter Trends',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      meta: '/api/cms/dashboard/meta',
    },
    'filters': [
      {
        'filter_id': 'state',
        'name': 'City',
        'facet_name_meta': 'state',
        'facet_name': 'state',
        'type': 'radio'
      },
    ]
  };

  public static Stock_Listing_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/autoLiveBlog',
      meta: '/api/cms/notified/topics',
      wireGet: '/api/cms/wire',
      wirePut: '/api/cms/wire',
      suggestion: '/api/cms/wire/suggestions'
    },
    fields: '',
    sortBy: 'createdDate',
    'apiEndPoints': [
      {
        'api_id': 'all_feeds',
        'name': 'All Feeds',
        'url': '/api/cms/wires'
      },
      {
        'api_id': 'search_feeds',
        'name': 'Feeds',
        'url': ''
      },
      {
        'api_id': 'one_story',
        'name': 'One Wire Story',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wires_meta',
        'name': 'Wires Meta',
        'url': '/api/cms/wire/meta'
      },
      {
        'api_id': 'save_wire',
        'name': 'Wires Update',
        'url': '/api/cms/wire'
      },
      {
        'api_id': 'wire_suggestions',
        'name': 'Dashboard Story Suggestions',
        'url': '/api/cms/wire/suggestions'
      }
    ],
    'headers': [
      {
        'header_id': 'stockName',
        'name': 'Stock Name',
        'model_id': 'stockName',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'stockCode',
        'name': 'Stock ID',
        'model_id': 'stockCode',
        'class': 'description',
        'type': 'text'
      },
      {
        'header_id': 'stockUrl',
        'name': 'Stock Page Url',
        'model_id': 'stockUrl',
        'class': 'stock-url',
        'type': 'text'
      },
      {
        'header_id': 'enable',
        'name': 'Enable',
        'model_id': 'enable',
        'class': 'stock-enable',
        'type': 'text'
      }
    ],
    'filters': [
      {
      'filter_id': 'enable',
      'name': 'Enable',
      'facet_name_meta': 'enable',
      'facet_name': 'enable',
      'type': 'radio'
      }
    ]
  };

  public static Cricket_LiveBlog_View = {
    'view_id': 'wires',
    'name': 'Feeds',
    'socketCodes': [3, 4],
    'subPages': [],
    'urls': {
      listing: '/api/cms/cricketLiveBlog',
    },
    fields: '',
    sortBy: 'createdDate',
    'headers': [
      {
        'header_id': 'matchName',
        'name': 'Match Name',
        'model_id': 'matchName',
        'class': 'headline',
        'type': 'text'
      },
      {
        'header_id': 'seriesname',
        'name': 'Series Name',
        'model_id': 'seriesname',
        'class': 'description',
        'type': 'text'
      },
      {
        'header_id': 'matchdate_ist',
        'name': 'Date',
        'model_id': 'matchdate_ist',
        'class': 'description',
        'type': 'text'
      },
      {
        'header_id': 'teama',
        'name': 'Team A',
        'model_id': 'teama',
        'class': 'description',
        'type': 'text'
      },
      {
        'header_id': 'teamb',
        'name': 'Team B',
        'model_id': 'teamb',
        'class': 'description',
        'type': 'text'
      },
      {
        'header_id': 'enable',
        'name': 'Enable',
        'model_id': 'enable',
        'class': 'stock-enable',
        'type': 'text'
      }
    ],
    'filters': [
      {
        'filter_id': 'matchStartDate',
        'name': 'Match Start Date',
        'facet_name_meta': 'matchStartDate',
        'facet_name': 'matchStartDate',
        'type': 'daterangeCricketLiveBlog'
      },
      {
      'filter_id': 'enabled',
      'name': 'Enabled',
      'facet_name_meta': 'enabled',
      'facet_name': 'enabled',
      'type': 'radioForCricketLiveBlog'
      }
    ]
  };

}
